import PocketBase from 'pocketbase'
import { TypedPocketBase } from './types/pocketbase-types'

export const pb = new PocketBase(import.meta.env.VITE_PB_URL) as TypedPocketBase
pb.autoCancellation(false) // Disable auto cancellation for queries
